import { render, staticRenderFns } from "./AddSubAccountDialog.vue?vue&type=template&id=3d248c30&scoped=true"
import script from "./AddSubAccountDialog.vue?vue&type=script&lang=ts"
export * from "./AddSubAccountDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d248c30",
  null
  
)

export default component.exports